import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  successMessage: string;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({ open, onClose, successMessage }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="success-dialog-title"
      aria-describedby="success-dialog-description">
      <DialogTitle id="success-dialog-title">Success</DialogTitle>
      <DialogContent>
        <DialogContentText id="success-dialog-description">{successMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
